// A full page load to `path`. Kept in its own module so tests can mock the
// navigation, which jsdom does not implement.
export function hardNavigate(path) {
  window.location.assign(path);
}
